import React from 'react';
import { Helmet } from 'react-helmet-async';
import { aboutContent } from '../mockData';
import WhatsAppCTA from '../components/WhatsAppCTA';

const About = () => {
  return (
    <div className="min-h-screen bg-black py-16 px-4">
      <Helmet>
        <title>About Us | Kingdom Auto Detailing Kerry | Professional Car Valeting Experts</title>
        <meta name="description" content="Learn about Kingdom Auto Detailing - your trusted car valeting and detailing experts in Co Kerry, Ireland. Committed to excellence in automotive care since establishment." />
        <meta name="keywords" content="about Kingdom Auto Detailing, car detailing experts Kerry, professional valeting team, auto detailing Tralee, Kerry car care specialists" />
        <link rel="canonical" href="https://kingdomautodetailing.ie/about" />
      </Helmet>

      <div className="max-w-4xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-12 text-center">
          About Us
        </h1>

        <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl p-8 md:p-12 mb-8 hover:scale-105 transition-transform duration-300">
          <h2 className="text-3xl font-bold text-white mb-6">{aboutContent.title}</h2>
          <p className="text-blue-100 text-lg leading-relaxed">{aboutContent.description}</p>
        </div>

        <div className="bg-zinc-900 rounded-3xl p-8 md:p-12 mb-8">
          <h3 className="text-3xl font-bold text-white mb-6">{aboutContent.commitment.title}</h3>
          <p className="text-gray-300 text-lg leading-relaxed">{aboutContent.commitment.text}</p>
        </div>

        <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl p-8 md:p-12">
          <h3 className="text-3xl font-bold text-white mb-6">Professional detailing</h3>
          <p className="text-blue-100 text-lg leading-relaxed">
            Kingdom Auto Detailing is dedicated to providing a 100% professional automotive detailing experience. 
            We use only the highest quality products and techniques to ensure your vehicle looks its absolute best.
          </p>
        </div>
      </div>

      {/* WhatsApp CTA */}
      <WhatsAppCTA />
    </div>
  );
};

export default About;